/**
 * Reverse the embed-URL transforms that the backend applies on attach so we
 * can show / let trainers copy the canonical "share" URL they originally
 * pasted.
 *
 *   YouTube  →  https://www.youtube-nocookie.com/embed/{id}?rel=0
 *           ←  https://www.youtube.com/watch?v={id}
 *
 *   Vimeo    →  https://player.vimeo.com/video/{id}
 *           ←  https://vimeo.com/{id}
 *
 *   Upload   →  proxy URL to GCS (already canonical — return as-is)
 *
 * Returns the canonical URL plus a short label suitable for badge text.
 */

const YT_EMBED_RE = /youtube(?:-nocookie)?\.com\/embed\/([A-Za-z0-9_-]+)/;
const VIMEO_PLAYER_RE = /player\.vimeo\.com\/video\/(\d+)/;

export function canonicalVideoUrl(slide) {
  if (!slide?.media_url) return null;
  const url = slide.media_url;
  if (slide.media_source === 'youtube') {
    const m = url.match(YT_EMBED_RE);
    if (m) return `https://www.youtube.com/watch?v=${m[1]}`;
  }
  if (slide.media_source === 'vimeo') {
    const m = url.match(VIMEO_PLAYER_RE);
    if (m) return `https://vimeo.com/${m[1]}`;
  }
  // 'upload' or any unrecognised pattern → return as stored
  return url;
}

export function videoSourceLabel(slide) {
  if (slide?.media_source === 'youtube') return 'YouTube';
  if (slide?.media_source === 'vimeo') return 'Vimeo';
  if (slide?.media_source === 'upload') return 'MP4';
  return 'Video';
}
